import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

/**
 * Dismissible explanation banner for list views the user may not be
 * familiar with. State is keyed by `storageKey` in localStorage so a
 * dismissal sticks across sessions on the same device.
 */
export function ExplanationNote({
  storageKey,
  children,
}: {
  storageKey: string;
  children: React.ReactNode;
}) {
  const [dismissed, setDismissed] = useState<boolean | null>(null);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(`fg.note.${storageKey}`) === '1');
    } catch {
      setDismissed(false);
    }
  }, [storageKey]);

  if (dismissed !== false) return null;

  const handleDismiss = () => {
    try { localStorage.setItem(`fg.note.${storageKey}`, '1'); } catch {}
    setDismissed(true);
  };

  return (
    <div className="relative px-4 py-3 mb-3 rounded-xl border border-border bg-primary/5 text-foreground/85">
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="absolute top-1.5 right-1.5 w-7 h-7 flex items-center justify-center rounded-full text-muted-foreground active:bg-accent"
      >
        <X size={14} />
      </button>
      <div className="pr-7 text-[13px] leading-relaxed">{children}</div>
    </div>
  );
}
